
import { Component, Prop, Vue } from "vue-property-decorator";
import UdcBannerGeneric from "@/components/UdcBannerGeneric.vue";

@Component({
  name: "celebrus-menu-notre-offre-2",
  components: {
    UdcBannerGeneric,
  },
})
export default class CelebrusMenuNotreOffre2 extends Vue {
  @Prop() private banner!: any;
  @Prop() private methods!: any;

  public data() {
    return {
      backgroundImg: this.getBackgroundImg(),
    };
  }

  private getProvenanceName() {
    if (this.banner.message_id) {
      return this.banner.message_id.match(/BAN_SECOURS/)
        ? "emergencyBanner"
        : "rtim";
    } else {
      return "rtim";
    }
  }

  private getBackgroundImg() {
    let bckgroundColor = "#ffffff";
    if (this.banner.imgBackground) {
      bckgroundColor = `#${this.banner.imgBackground}`;
    }
    if (this.banner.imgBanner) {
      const imgBannerArray = this.banner.imgBanner.split(" ");
      const imgBannerName = imgBannerArray[0];
      const imgBannerParams = imgBannerArray.slice(1).join(" ");
      const urlBackgroundImg =
        this.banner.celebrusAssetsPathFinder + imgBannerName + ".png";
      return `background: ${bckgroundColor} url('${urlBackgroundImg}') ${imgBannerParams}`;
    } else  if (this.banner.mainClass !== "gab-20") {
      return `background: ${bckgroundColor};`;
    }
  }
}
